import { Component, OnInit, Input } from '@angular/core';
import { CustomRuleService } from '../../custom-rule/custom-rule.service';
import {ObjectNames,Severity,Status} from '../../constants/constants';
import { PricebookService } from '../pricebook.service';
import { BehaviorSubject, Subject } from 'rxjs';
import { FormGroup, FormBuilder, Validators} from '@angular/forms';
import { AppMainComponent } from 'src/app/app.main.component';
import { ConfirmationService, MessageService } from 'primeng/api';
import { TitleCasePipe } from '@angular/common';
import { debounceTime } from "rxjs/operators";
import { AppMainService } from 'src/app/app-main.service';

@Component({
  selector: 'app-assign',
  templateUrl: './assign.component.html',
  styleUrls: ['./assign.component.scss']
})
export class AssignComponent implements OnInit {

  assignForm: FormGroup;
  isDisabled: boolean=false;
  isAdd: boolean=false;
  assignedTiers=[];
  displayAssignPriceTier = false;
  allModules = [];
  allChannels = [];
  @Input() types = [];
  @Input() allTiers = [];
  discountTypesTiers=[];
  discountType;
  options = ObjectNames.priceBooksConstants.PriceRuleConstant;
  discountGroupType = ObjectNames.priceBooksConstants.DiscountGroupType;
  discountQtyType = ObjectNames.priceBooksConstants.DiscountQtyType;
  selectedOption;
  savedTier;
  displayAccountTB: boolean=false;
  selectedAccounts=[];
  allAccountsData=[];
  accountsData=[];
  channelId: number=0;
  typeId:  number=0;
  pageNumber:number=1;
  totalRecords:number=0;
  first: number=0;
  pageSize:number=15;
  searchValue:string='';
  modelChanged = new Subject<any>();
  isEdit = false;
  noAccountsFindOrLoadingText: string='';

  constructor(
    private customRuleService:CustomRuleService,private fb: FormBuilder,private app: AppMainComponent,private messageService: MessageService,
    private pricebookService: PricebookService,private titleCasePipe: TitleCasePipe,private appService: AppMainService
  ) {
    this.modelChanged.pipe(
      debounceTime(700))
      .subscribe((type) => {
        this.onAccountGlobalSearch();
    })
  }

  ngOnInit(): void {
    this.loadAssignedTiers();
    this.assignForm = this.fb.group({
      id: [0],
      createdSource: [this.app.userIP],
      updatedSource: [this.app.userIP],
      createdBy: [this.app.userId],
      updatedBy: [this.app.userId],
      createdDate: [new Date().toISOString()],
      updatedDate: [new Date().toISOString()],
      moduleId: [null, [Validators.required]],
      moduleName: [''],
      channelId:[null,  [Validators.required]],
      channel: [''],
      typeId: [null,  [Validators.required]],
      type: [null],
      ruleApplyTypeId: [0],
      statusId: [1],
      organizationId: [this.app.companyId],
      preferredPriceTier: [null, [Validators.required]]
    })
  }

  loadAssignedTiers(){
    this.pricebookService.getAllAssignedTiers().subscribe(tiers=>{
      this.assignedTiers =tiers;
    })
  }

  showAssignPriceTier(){
    this.loadModules();
    this.isDisabled =false;
    this.isAdd = true;
    this.assignForm = this.fb.group({
      id: [0],
      createdSource: [this.app.userIP],
      updatedSource: [this.app.userIP],
      createdBy: [this.app.userId],
      updatedBy: [this.app.userId],
      createdDate: [new Date().toISOString()],
      updatedDate: [new Date().toISOString()],
      moduleId: [null, [Validators.required]],
      moduleName: [''],
      channelId:[null,  [Validators.required]],
      channel: [null],
      typeId: [null,  [Validators.required]],
      type: [null],
      ruleApplyTypeId: [this.options[1].id],
      statusId: [1],
      organizationId: [this.app.companyId],
      preferredPriceTier: [null, [Validators.required]]
    })
    this.displayAssignPriceTier = true;
  }

  eidtAssignPriceTier(value){
    this.savedTier =value;
    this.isDisabled=false;
    this.isAdd=false;
    this.assignForm.patchValue(value);
    this.loadModules('edit',value);
    const filteredDiscountType = this.types?.filter(tp=> tp.id==value.typeId)[0];
    this.assignForm.controls['typeId'].setValue(filteredDiscountType);
    this.loadTiers( this.assignForm.controls['typeId'].value,'edit',value);
    this.displayAssignPriceTier = true;
  }

  loadModules(action?,value?){
    this.customRuleService.getAllModules().subscribe(modules=>{
      this.allModules = modules.filter(m=> (m.name=='Account'));
      if(action=='edit'){
        const filteredModule = this.allModules?.filter(m=> m.id=value.moduleId)[0];
        this.assignForm.controls['moduleId'].setValue(filteredModule);
        this.loadConfigurations(this.assignForm.controls['moduleId'].value,'edit',value)
      }
    })
  }

  loadConfigurations(e,action?,value?){
    const moduleName = e.id;
      this.customRuleService.getChannelByModuleId(moduleName).subscribe(ch=>{
        // const typeConfig = configs.filter(s => s.name == ObjectNames.customConstants.Account_Channel_Object && s.typeId== ObjectNames.customConstants.Account_Channel_TypeId)[0];
        // this.allChannels = JSON.parse(typeConfig.configurationDetails[0].configJSONValue);
        this.allChannels = ch;
        if(action=='edit'){
          const filteredChannel = this.allChannels?.filter(ch=> ch.id==value.channelId)[0];
          this.assignForm.controls['channelId'].setValue(filteredChannel);
        }
      })
  }

  loadTiers(e,action?,value?){
    if(e.name == this.discountQtyType){
     const qtyTiers = this.allTiers.filter(d=> d.name== this.discountQtyType).map(tier=> tier.childPriceTier)[0];
     this.discountTypesTiers = qtyTiers?.filter(t=> t.isVisible==true && t.isCustom==false && t.statusId==Status.ACTIVE);
     if(action=='edit'){
      // const inActiveTier = this.discountTypesTiers?.filter(tier=> tier.id==value.preferredPriceTier[0]?.priceTierId)[0];
      // if(!inActiveTier){
      //  this.discountTypesTiers.push(value.preferredPriceTier[0]?.priceTier);
      // }
      const filteredTier = this.discountTypesTiers?.filter(tier=> tier.id==value.preferredPriceTier[0]?.priceTierId)[0];
      this.assignForm.controls['preferredPriceTier'].setValue(filteredTier);
     }
    } else if(e.name == this.discountGroupType) {
      const discountTypesTiers = this.allTiers.filter(d=> d.name== this.discountGroupType).map(tier=> tier.childPriceTier)[0];
      this.discountTypesTiers = discountTypesTiers?.filter(t=> t.isVisible==true && t.statusId==Status.ACTIVE);
      if(action=='edit'){
        const filteredTier =[];
        //const inactiveGroups =[];
        value.preferredPriceTier?.forEach(element => {
          const tier = this.discountTypesTiers?.filter(tier=> tier.id==element?.priceTierId)[0];
          // if(!tier){
          //   const inactiveGroup = discountTypesTiers?.filter(t=> t.id==element.priceTierId)[0];
          //   this.discountTypesTiers.push(inactiveGroup)
          // };
          filteredTier.push(tier);
        });
        this.assignForm.controls['preferredPriceTier'].setValue(filteredTier);
       }
    }
  }

  setPreferredPriceTier(value){
    const preferredTiers =[];
    value.preferredPriceTier.forEach(element => {
      const tierEach ={
        id: (this.savedTier?.preferredPriceTier?.filter(t=> t.priceTierId==element?.id)[0]?
        (this.savedTier?.preferredPriceTier?.filter(t=> t.priceTierId==element?.id).map(tier=> tier.id)[0]):0),
        createdSource: this.app.userIP,
        updatedSource: this.app.userIP,
        createdBy: this.app.userId,
        updatedBy: this.app.userId,
        createdDate: new Date().toISOString(),
        updatedDate: new Date().toISOString(),
        priceTierId: element.id,
        priceTierRulesId: (this.isAdd?0:this.savedTier?.id),
        organizationId: this.app.companyId,
        typeId: value.typeId?.id,
        statusId: Status.ACTIVE
      }
      preferredTiers.push(tierEach);
    });
     return preferredTiers;
  }

  save(value){
    this.appService.isShowSpinner('pricebook');
    this.isDisabled=true;
    value.channel = value.channelId?.name;
    value.channelId = value.channelId?.id;
    value.moduleName = value.moduleId?.name;
    value.moduleId = value.moduleId?.id;
    if(value.typeId?.name==this.discountQtyType){
     const priceTiers=[];
     const preferredTier = {
      id: (this.savedTier?.preferredPriceTier?.filter(t=> t.priceTierId==value.preferredPriceTier?.id)[0]?
       (this.savedTier?.preferredPriceTier?.filter(t=> t.priceTierId==value.preferredPriceTier?.id).map(tier=> tier.id)[0]):0),
      createdSource: this.app.userIP,
      updatedSource: this.app.userIP,
      createdBy: this.app.userId,
      updatedBy: this.app.userId,
      createdDate: new Date().toISOString(),
      updatedDate: new Date().toISOString(),
      priceTierId: value.preferredPriceTier?.id,
      priceTierRulesId: (this.isAdd?0:this.savedTier?.id),
      organizationId: this.app.companyId,
      typeId: value.typeId?.id,
      statusId: Status.ACTIVE
    }
    priceTiers.push(preferredTier);
    value.preferredPriceTier=priceTiers;
    }else if(value.typeId?.name==this.discountGroupType){
      value.preferredPriceTier = this.setPreferredPriceTier(value);
    }
    value.typeId = value.typeId?.id;
    //console.log(value)
    if(this.isAdd){
      this.pricebookService.addAssignedTierRule(value).then(() => {
        this.messageService.add({ severity: Severity.Success, summary: this.titleCasePipe.transform(Severity.Success), detail: 'Price Tier Added successfully...' });
        this.loadAssignedTiers();
        this.appService.isHideSpinner('pricebook');
        this.isDisabled=false;
        this.displayAssignPriceTier = false;
      }).catch(() => {
        this.displayAssignPriceTier = false;
        this.isDisabled=false;
        this.appService.isHideSpinner('pricebook');
        this.messageService.add({ severity: Severity.Error, summary: this.titleCasePipe.transform(Severity.Error), detail: 'Error occurred while saving data...' });
      });
    }else{
      this.pricebookService.updateAssignedTierRule(value).then(() => {
        this.messageService.add({ severity: Severity.Success, summary: this.titleCasePipe.transform(Severity.Success), detail: 'Price Tier Updated successfully...' });
        this.loadAssignedTiers();
        this.isDisabled=false;
        this.displayAssignPriceTier = false;
        this.appService.isHideSpinner('pricebook');
      }).catch(() => {
        this.displayAssignPriceTier = false;
        this.isDisabled=false;
        this.appService.isHideSpinner('pricebook');
        this.messageService.add({ severity: Severity.Error, summary: this.titleCasePipe.transform(Severity.Error), detail: 'Error occurred while saving data...' });
      });
    }
  }

  viewAccounts(type,channelId){
    this.selectedAccounts=[];
    this.isEdit=false;
    this.loadTiers(type);
    this.channelId=channelId;
    this.typeId = type?.id;
    this.first=0;
    this.pageNumber=1;
    this.searchValue='';
    this.loadAccounts(this.pageNumber,this.pageSize,channelId,type?.id,this.searchValue);
    this.displayAccountTB = true;
  }

  changed(event){
    this.modelChanged.next("");
  }

  getAccountsData(event){
    this.pageNumber = (event.first / event.rows) + 1;
    this.first= event.first;
    this.loadAccounts(this.pageNumber,this.pageSize,this.channelId,this.typeId,this.searchValue);
  }

  cancelDialog(){
    this.displayAccountTB=false;
    this.isEdit=false;
    this.first = 0;
  }

  onAccountGlobalSearch(){
    this.first=0;
    this.pageNumber=1;
    this.loadAccounts(this.pageNumber,this.pageSize,this.channelId,this.typeId,this.searchValue);
  }

  onChangeAccountAssignRule(account){
    if(account.priceTierTypeName==this.discountQtyType || (account.priceTierTypeName==this.discountGroupType && account.preferredTier?.length>0)){
      account.isChecked=true;
      const exists = this.selectedAccounts?.filter((a:any)=> a.id==account.id)[0];
      if(exists){
        const index = this.selectedAccounts.indexOf(account);
        this.selectedAccounts.splice(index,1);
        this.selectedAccounts.push(account);
      }else{
        this.selectedAccounts.push(account);
      }
    }else{
      account.isChecked=false;
      const index = this.selectedAccounts.indexOf(account);
      this.selectedAccounts.splice(index,1);
    }
   //console.log(this.selectedAccounts)
  }

  setPreferredTiers(tiers){
   const preferred =[];
   tiers.forEach(element => {
    const tierEach = this.discountTypesTiers?.filter(t=> t.id==element.tierId)[0];
    if(tierEach){
      preferred.push(tierEach);
    }
   });
   return preferred;
  }

  loadAccounts(pageNumber,pageSize,channelId,typeId,searchValue){
    this.appService.isShowSpinner('pricebook');
    this.pricebookService.getAllAccounts(pageNumber,pageSize,channelId,typeId,searchValue).then(account => {
      let { accounts, headers } = account;
      accounts = accounts == null ? [] : accounts;
      headers = headers == null ? [] : headers;
      this.totalRecords = headers['TotalCount'];
      this.allAccountsData = [];
      this.accountsData = [];
      if(accounts.length>0){
        for (let l of accounts) {
          let streetName;
          let cityName;
          let stateName;

          for(let add of l.accountAddresses){
            if(add.address?.isDefault){
              streetName = add.address?.streetAddress1 + ' ' + add.address?.streetAddress2;
              cityName = add.address?.city?.name;
              stateName = add.address?.state?.name;
             }
          }
          let eachAccount = {
            id: l.id,
            name: l.businessName,
            street: streetName,
            city: cityName,
            state: stateName,
            priceTierTypeName: l.priceTierTypeName,
            preferredTier: (l.priceTierTypeName==this.discountQtyType? this.discountTypesTiers?.filter(t=> t.id== l.accountProductPriceTiers[0]?.tierId)[0]:
             this.setPreferredTiers(l.accountProductPriceTiers)),
            isChecked: false
          }
          this.allAccountsData.push(eachAccount);
        }
        this.accountsData = JSON.parse(JSON.stringify(this.allAccountsData));
        this.accountsData.forEach((element:any) => {
          const alreadyChecked:any = this.selectedAccounts?.filter((account:any)=> account.id==element.id)[0];
          if(alreadyChecked){
            element.isChecked=true;
            element.preferredTier = alreadyChecked.preferredTier
          }
        });
        this.appService.isHideSpinner('pricebook');
      }else{
        this.totalRecords=0;
        this.appService.isHideSpinner('pricebook');
        this.noAccountsFindOrLoadingText = 'No Accounts found.';
      }
    })
  }

  setAssignTiers(){
    const accounts=[];
    this.selectedAccounts?.forEach(element => {
      if(element.priceTierTypeName==this.discountQtyType){
        const accountEach={
          id: 0,
          createdSource: this.app.userIP,
          updatedSource: this.app.userIP,
          createdBy: this.app.userId,
          updatedBy: this.app.userId,
          createdDate: new Date().toISOString(),
          updatedDate: new Date().toISOString(),
          accountId: element.id,
          tierId: element.preferredTier?.id,
          productPriceTierId: 0,
          productId: 0,
          price: 0,
          typeId: element.preferredTier?.typeId,
          statusId: Status.ACTIVE
        }
        accounts.push(accountEach);
      }else if(element.priceTierTypeName==this.discountGroupType){
        element.preferredTier?.forEach(tier => {
          const accountEach={
            id: 0,
            createdSource: this.app.userIP,
            updatedSource: this.app.userIP,
            createdBy: this.app.userId,
            updatedBy: this.app.userId,
            createdDate: new Date().toISOString(),
            updatedDate: new Date().toISOString(),
            accountId: element.id,
            tierId: tier.id,
            productPriceTierId: 0,
            productId: 0,
            price: 0,
            typeId: tier?.typeId,
            statusId: Status.ACTIVE
          }
          accounts.push(accountEach);
        });
      }
    });
    return accounts;
  }

  assignBulk(){
    this.isDisabled=true;
    const accountReq = this.setAssignTiers();
    //console.log(accountReq)
    this.pricebookService.updateBulkAssignedTierRule(accountReq).then(() => {
      this.messageService.add({ severity: Severity.Success, summary: this.titleCasePipe.transform(Severity.Success), detail: 'Accounts Updated successfully...' });
      this.isDisabled=false;
      this.displayAccountTB = false;
      this.appService.isHideSpinner('pricebook');
    }).catch(() => {
      this.displayAccountTB = false;
      this.isDisabled=false;
      this.appService.isHideSpinner('pricebook');
      this.messageService.add({ severity: Severity.Error, summary: this.titleCasePipe.transform(Severity.Error), detail: 'Error occurred while saving data...' });
    });
  }

}
